import { useMemo } from 'react';

import { useFloorPlan } from 'Src/feature/floor-plan/useFloorPlan';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { useRevenueCenters } from 'Src/feature/revenue-center/useRevenueCenter';
import { useTerminal } from 'Src/feature/terminal/useTerminal';

const useTerminalDefaults = () => {

  const revenueCenter = useRevenueCenters.query.currentForTerminal();
  const terminalSettings = useTerminal.query.settings();
  const { employeeId } = useCurrentOperator();
  const floorPlans = useFloorPlan.query.list();

  return useMemo(() => {
    const revenueCenterId = revenueCenter.data?.id;
    let loading = true;
    let view = terminalSettings.data?.defaultView;
    const orderTypeId = terminalSettings.data?.defaultOrderTypeId;
    const activeFloorPlanForRevenueCenter = floorPlans.data?.find((fp) => fp.isDefault && revenueCenterId === fp.revenueCenterId);
    const floorPlanId = activeFloorPlanForRevenueCenter?.id;
    const partySizeType = terminalSettings.data?.partySizeType;
    const partySize = terminalSettings.data?.partySizeType === 'TableSeatsElseRevCenter' ? revenueCenter.data?.defaultPartySize : undefined;
    const checkNameInputType = terminalSettings.data?.checkNameInputType;
    const startTabWithCard = terminalSettings.data?.startTabWithCard;
    if (view === 'CheckList') {
      // the Check List view will be displayed every time a user logs in
      // The terminal's default revenue center will be applied as a filter
      // The current employee will be applied as a filter
      loading = terminalSettings.isLoading || revenueCenter.isLoading;
    } else if (view === 'FloorPlan') {
      loading = terminalSettings.isLoading || revenueCenter.isLoading || floorPlans.isLoading;
      const activeFloorPlanForRevenueCenter = floorPlans.data?.find((fp) => fp.isDefault && revenueCenterId === fp.revenueCenterId);
      if (activeFloorPlanForRevenueCenter) {
        // Given the terminal's Default View is set to Floor Plan
        // and the terminal's default Revenue Center has an active floor plan
        // the Floor Plan view will be displayed every time a user logs in
        // the terminal's default Revenue Center will be selected in the top bar
        // the floor plan of the default revenue center will be displayed
      } else {
        // Given the terminal's Default View is set to Floor Plan
        // and the terminal's default Revenue Center DOES NOT have an active floor plan
        // the Check List view will be displayed every time a user logs in
        // The terminal's default revenue center will be applied as a filter
        // The current employee will be applied as a filter
        view = 'CheckList';
      }
    } else if (view === 'NewCheck') {
      // Given the terminal's Default View is set to New Check
      // a New Check will be created and the Order View will be displayed every time a user logs in
      // The new check will be assigned the terminal's default Revenue Center and Order Type
      // The new check will not be associated with a Table
      // The new check will use the revenue center's default party size
      loading = terminalSettings.isLoading || revenueCenter.isLoading;
    }
    return { loading, view, revenueCenterId, employeeId, floorPlanId, orderTypeId, partySizeType, partySize, checkNameInputType, startTabWithCard };
  }, [
    revenueCenter.data?.id,
    revenueCenter.data?.defaultPartySize,
    revenueCenter.isLoading,
    terminalSettings.data?.defaultView,
    terminalSettings.data?.defaultOrderTypeId,
    terminalSettings.data?.partySizeType,
    terminalSettings.data?.checkNameInputType,
    terminalSettings.data?.startTabWithCard,
    terminalSettings.isLoading,
    employeeId,
    floorPlans.data,
    floorPlans.isLoading,
  ]);
};

export { useTerminalDefaults };
